export const PAYMENT_ADVERTISING_TYPES = {
  CART: 'cart',
  PRODUCT: 'product',
  LANDING: 'landing',
  SEARCH: 'search',
}
